<template>
	<div class="phone_product_show_layout">
		<div class="phone_now_path_layout">

			<div class="show_now_path_content_item" style="margin-left: 20px;">
				{{ now_id_arr[0] == '4' ? '项目案例' : '产品中心' }}
			</div>
			<div class="show_now_path_content_item_2">
				>
			</div>
			<div class="show_now_path_content_item">
				{{ now_data.title }}
			</div>
		</div>
		<div class="show_product_img_layout">
			<div :class="'show_product_img ' + 'page_new_content_item_img_' + (now_data.id)"
				v-show="now_id_arr[0] == '1'"></div>
			<!-- :style="' '+now_data.show_style" -->

			<div :class="'show_product_img ' + 'page_new_content_item_img_2_' + now_data.id"
				v-show="now_id_arr[0] == '2'"></div>

			<div :class="'show_product_img ' + 'api_show_img_' + (now_data.id)" v-show="now_id_arr[0] == '3'"></div>

			<div :class="'show_product_img ' + 'case_img_' + (now_data.id)" v-show="now_id_arr[0] == '4'"></div>
		</div>
		<div class="show_product_content_title">
			▲{{ now_data.title }}
		</div>
		<div class="show_product_content_text_layout">
			<div class="show_product_content_text" v-for="item in now_data.show_content"
				:style="now_data.show_content_style">
				{{ item }}
			</div>

		</div>

		<div v-show="now_id == '1_1'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">AI赋能</span>
							，产品采用了AI 检测模型，可以快速检测到金属膜上的缺陷，比如锡珠，头发，少料，多料等

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化</span>
							，被测试的金属膜加载到治具上，使用扫码枪后，治具被自动推进检测区域，相机采集图片，进行缺陷检测

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以检测到小至0.1毫米（直径）的异物

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							基于视觉的工业产品缺陷检测，可以精准的检测到产品上的裂缝，异物，锡珠等

						</li>
					</ul>
					<div style="width: 100%;height: 40px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 410px;">
				<div class="show_product_content_3_img_1_1"></div>
				<!-- <div class="show_product_content_3_img_1_2"></div> -->
				<!-- <div class="show_product_content_3_img_1_3"></div> -->
			</div>
			<div class="show_product_content_3_layout" style="height: 410px;">

				<div class="show_product_content_3_img_1_2"></div>

			</div>
			<div class="show_product_content_3_layout" style="height: 410px;">
				<!-- <div class="show_product_content_3_img_1_1"></div> -->
				<!-- <div class="show_product_content_3_img_1_2"></div> -->
				<div class="show_product_content_3_img_1_3"></div>
			</div>
		</div>
		<div v-show="now_id == '1_2'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">AI赋能</span> -->
							支持平面、斜面、锥形研磨


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化</span> -->
							支持持0~90°间任意角度


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							支持实时监控裸纤与转盘间距， 以及研磨过中光纤端面外形


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							配备专用研磨夹具


						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 320px;">
				<div class="show_product_content_3_img_2">

				</div>
			</div>
		</div>

		<div v-show="now_id == '1_3'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">AI赋能</span> -->
							柜体容纳老化层数及路数可根据要求定制
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化</span> -->
							模块化设计，可维护、拓展性良好
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							兼容水冷及风冷散热
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							光斑模式，光谱实时检测
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							实时监控激光器隔离器表面温度、光功率变化
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							老化数据实时反馈及储存
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 360px;">
				<div class="show_product_content_3_img_3">

				</div>
			</div>
		</div>

		<div v-show="now_id == '1_4'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">AI赋能</span>
							，产品采用了AI 检测模型，可以快速检测到目标物上的缺陷，比如锡珠，头发，少料，多料等

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化</span>
							，被测试的金属膜加载到治具上，使用扫码枪后，治具被自动推进检测区域，相机采集图片，进行缺陷检测

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以检测到小至0.1毫米（直径）的异物

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							假点少，在线打标判废
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							高度智能化建模，一键导入Gerber资料
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							检测速度快，可达4-6m/min
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							使用正面光，精准检测20μm的微开微短，检测幅宽250mm-520mm
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 1000px;">
				<div class="show_product_content_3_img_1"></div>
				<div class="show_product_content_3_img_1_4"></div>
			</div>
		</div>

		<div v-show="now_id == '4_4'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以精准识别各种异物。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化</span>
							，被检测的防尘盖加载到治具上，治具被自动推进检测区域，相机采集图片，进行缺陷检测
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">AI赋能</span> -->
							使用我司深度学习算法，收集NG样本，进行打标训练，针对一些误检区域进行屏蔽区训练，操作简便，识别率高。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化</span> -->
							通过图像分割输出不同缺陷的概率图，实现缺陷分类以及面积管控筛选。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							深度学习算法高效稳定，检测良率达99%。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							实现运控视觉一体化，方便操作。


						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 670px;">
				<div class="show_product_content_51">

				</div>
			</div>
		</div>

		<div v-show="now_id == '4_5'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以精准识别各种异物。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化</span>
							，被检测的电池仓加载到治具上，治具被自动推进检测区域，相机采集图片，进行缺陷检测
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							深度学习算法高效稳定，检测良率达99%。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							实现运控视觉一体化，方便操作。


						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<!-- 			<div class="show_product_content_3_layout" style="height: 320px;">
						<div class="show_product_content_3_img_2">
							
						</div>
					</div> -->
		</div>

		<div v-show="now_id == '4_6'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以精准识别各种异物。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化</span>
							，被检测的电池仓加载到治具上，治具被自动推进检测区域，相机采集图片，进行缺陷检测
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							深度学习算法高效稳定，检测良率达99%。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							实现运控视觉一体化，方便操作。


						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<!-- 			<div class="show_product_content_3_layout" style="height: 320px;">
						<div class="show_product_content_3_img_2">
							
						</div>
					</div> -->
		</div>

		<div v-show="now_id == '1_8'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以实现精准识别


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化</span> -->
							高分辨率、高可靠性、全自动
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							采用全新的数字图像方案，支持网络传输数据


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							多种夹具对应不同的产品的测试
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							生成详细报告便于记录数据
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 650px;">
				<div class="show_product_content_show_1">

				</div>
			</div>
		</div>

		<div v-show="now_id == '1_9'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以精准识别各种样本


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化</span> -->
							质量检测，微米级别测量
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							光纤形状、角度识别、尺寸识别等
						</li>

						<li style="font-size: 18px;margin-top: 5px;">
							辅助生产，辅助设备仪器调试校准等
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							实现运控视觉一体化，方便操作
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 420px;">
				<div class="show_product_content_3_img_9_1">

				</div>
			</div>
		</div>

		<div v-show="now_id == '2_1'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化管理：</span>
							无需人工干预，系统通过视觉识别设备和操作人员，自动完成借还设备记录
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">实时库存更新：</span>
							确保设备库存信息的实时性和准确性，减少库存错误
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高效管理：</span>
							减少人工操作时间，提升仓库管理效率
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							自动监控工作人员从仓库中取走或归还设备的操作
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							实时库存统计
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							人员身份确认
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 780px;">
				<div class="show_product_content_3_img_4"></div>
				<div class="show_product_content_3_img_5"></div>
				<div class="show_product_content_3_img_6"></div>
			</div>
		</div>

		<div v-show="now_id == '2_2'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化管理：</span> -->
							实时监控光斑形状以及变化
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">实时库存更新：</span> -->
							测量激光光束的M²大小、束腰直径D0、发散角theta、椭圆度等
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高效管理：</span> -->
							符合国际ISO11146标准
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							2D，3D 伪彩色光束轮廓
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							产品测量功率范围、测量波长可定制
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 700px;">
				<div class="show_product_content_3_img_7"></div>
				<div class="show_product_content_3_img_7_1"></div>
			</div>
		</div>
		<div v-show="now_id == '2_3'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化管理：</span> -->
							实时处理模拟飞机屏幕视频流
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">实时库存更新：</span> -->
							框选识别功能
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高效管理：</span> -->
							多目标识别
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							可以识别飞行高度与飞行过载
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 600px;">
				<div class="show_product_content_3_img_8">

				</div>
			</div>
		</div>

		<div v-show="now_id == '2_4'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">图片预处理：</span>
							使用OpenCV读取图像文件，对图像进行裁剪，自适应阈值二值化，轮廓获取
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">圆的识别：</span>
							采用霍夫圆算法提取图片中的圆
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">角度计算：</span>
							计算圆心连接线和轴线之间的夹角
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 800px;">
				<div class="show_product_content_3_img_9"></div>
				<div class="show_product_content_3_img_10"></div>
				<div class="show_product_content_3_img_11"></div>
			</div>
		</div>

		<div v-show="now_id == '2_5'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					系统特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度：</span>
							检测系统采用了高精度的相机进行采样，可实现精准识别
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高度准确性：</span> -->
							深度学习算法高效稳定，检测识别率达99%。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">实时响应性：</span> -->
							实现运控视觉一体化，方便操作。
						</li>

						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化与智能化：</span> -->
							质量检测，微米级别测量
						</li>
						<!-- 								<li style="font-size: 18px;margin-top: 5px;">
									<span style="color:#00ffff;font-size: 18px;">实时监控与数据分析：</span>
									系统应能实时监控设备状态
								</li> -->
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 450px;">
				<div class="show_product_content_img_57"></div>
				<!-- <div class="show_product_content_3_img_12_arrow"></div> -->

			</div>
		</div>

		<div v-show="now_id == '2_6'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					系统特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高度准确性：</span> -->
							不同物联感知传感器统一管理
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">实时响应性：</span> -->
							丰富的行业应用场景
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">稳定与鲁棒性：</span> -->
							提供统一RESTful API 接口，支持下载
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化与智能化：</span> -->
							软件完全自主研发，提供定制化服务
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">实时监控与数据分析：</span> -->
							部署灵活，兼容性好
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<!-- 					<div class="show_product_content_3_layout" style="height: 610px;">
						<div class="show_product_content_3_img_12_arrow"></div>
						<div class="show_product_content_3_img_12"></div>
						
					</div> -->
		</div>

		<div v-show="now_id == '2_7'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					<!-- 系统特点 -->
				</div>
				<div class="show_product_content_2_content">
					<ul>

					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<!-- 					<div class="show_product_content_3_layout" style="height: 610px;">
						
						<div class="show_product_content_show_2"></div>
						
					</div> -->
		</div>

		<div v-show="now_id == '4_1'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					系统特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高度准确性：</span>
							能够准确识别设备的潜在故障、异常行为
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">实时响应性：</span>
							具备实时响应能力，一旦发现异常，应能迅速生成预警
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">稳定与鲁棒性：</span>
							具有高精度的识别和分析能力，同时应具有抗干扰、抗噪声和抗环境变化的能力
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化与智能化：</span>
							能自动化执行巡检任务，通过AI学习和优化，提高预警的准确性和效率，减少人工干预
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">实时监控与数据分析：</span>
							系统应能实时监控设备状态
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 610px;">
				<div class="show_product_content_3_img_12_arrow"></div>
				<div class="show_product_content_3_img_12"></div>

			</div>
		</div>

		<div v-show="now_id == '4_2'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					系统特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">车牌信息识别精度：</span>
							高精度的车牌信息识别能力
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">系统处理速度：</span>
							实时响应，确保车辆的快速进出
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">车辆追踪与定位：</span>
							实时追踪和定位车辆的位置
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">安全监控：</span>
							具备车辆安全监控功能，如超速、疲劳驾驶、违规行为等
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">安全性与隐私保护：</span>
							处理车牌信息时，确保数据的安全性和隐私保护
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 700px;">
				<div class="show_product_content_3_img_13"></div>
			</div>
		</div>

		<div v-show="now_id == '4_3'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					系统特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">预测准确性：</span>
							准确预测和识别高压设备的异常，如电缆过热、破损等
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">预警速度：</span>
							能快速响应，一旦发现异常，应能立即通知维护人员并启动应急处理程序
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">实时监控与数据分析：</span>
							实时监控设备状态，并通过大数据分析，提供故障预警和预防性维护
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">精度与稳定性：</span>
							具备高精度的设备状态监测和故障定位能力
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化与智能化：</span>
							能实现自动化巡检，减少人工干预，提高效率
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">数据分析与决策支持：</span>
							能收集并分析大量数据，生成报告，为管理层提供决策支持
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 610px;">
				<div class="show_product_content_3_img_14"></div>
			</div>
		</div>

	</div>



	<div class="page1_main_layout">
		<div class="show_now_path_layout">
			<div class="show_now_path_content">

				<div class="show_now_path_content_item">
					{{ now_id_arr[0] == '4' ? '项目案例' : '产品中心' }}
				</div>
				<div class="show_now_path_content_item_2">
					>
				</div>
				<div class="show_now_path_content_item">
					{{ now_data.title }}
				</div>
			</div>
		</div>
		<div class="page2_main_content_layout">
			<div class="show_product_img_layout">
				<div :class="'show_product_img ' + 'page_new_content_item_img_' + (now_data.id)"
					v-show="now_id_arr[0] == '1'" :style="' ' + now_data.show_style"></div>

				<div :class="'show_product_img ' + 'page_new_content_item_img_2_' + now_data.id"
					v-show="now_id_arr[0] == '2'" :style="' ' + now_data.show_style"></div>

				<div :class="'show_product_img ' + 'api_show_img_' + (now_data.id)" v-show="now_id_arr[0] == '3'"
					:style="' ' + now_data.show_style"></div>

				<div :class="'show_product_img ' + 'case_img_' + (now_data.id)" v-show="now_id_arr[0] == '4'"
					:style="' ' + now_data.show_style"></div>

				<!-- 				<div
					:class="'show_product_img ' + 'case_img_1' " 
					id="case_img_1"
					style="display: none;"
					:style="' '+now_data.show_style"
				></div>
				
				<div
					:class="'show_product_img ' + 'case_img_2' " 
					id="case_img_2"
					style="display: none;"
					:style="' '+now_data.show_style"
				></div>
				
				<div
					:class="'show_product_img ' + 'case_img_3' " 
					id="case_img_3"
					style="display: none;"
					:style="' '+now_data.show_style"
				></div> -->


			</div>

			<div class="show_product_content">
				<div class="show_product_content_title">
					▲{{ now_data.title }}

				</div>
				<div class="show_product_content_text_layout">
					<div class="show_product_content_text" v-for="item in now_data.show_content"
						:style="now_data.show_content_style">
						{{ item }}
					</div>

				</div>

			</div>
		</div>

		<div v-show="now_id == '1_1'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">AI赋能</span>
							，产品采用了AI 检测模型，可以快速检测到金属膜上的缺陷，比如锡珠，头发，少料，多料等

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化</span>
							，被测试的金属膜加载到治具上，使用扫码枪后，治具被自动推进检测区域，相机采集图片，进行缺陷检测

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以检测到小至0.1毫米（直径）的异物

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							基于视觉的工业产品缺陷检测，可以精准的检测到产品上的裂缝，异物，锡珠等

						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 550px;">

				<!-- 				<div class="show_product_content_3_img_1_1"></div>
				<div class="show_product_content_3_img_1_2"></div> -->
				<div class="show_product_content_3_img_1_3"></div>
			</div>
		</div>

		<div v-show="now_id == '1_2'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">AI赋能</span> -->
							支持平面、斜面、锥形研磨


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化</span> -->
							支持持0~90°间任意角度


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							支持实时监控裸纤与转盘间距， 以及研磨过中光纤端面外形


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							配备专用研磨夹具


						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 320px;">
				<div class="show_product_content_3_img_2">

				</div>
			</div>
		</div>

		<div v-show="now_id == '1_3'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">AI赋能</span> -->
							柜体容纳老化层数及路数可根据要求定制
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化</span> -->
							模块化设计，可维护、拓展性良好
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							兼容水冷及风冷散热
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							光斑模式，光谱实时检测
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							实时监控激光器隔离器表面温度、光功率变化
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							老化数据实时反馈及储存
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 360px;">
				<div class="show_product_content_3_img_3">

				</div>
			</div>
		</div>

		<div v-show="now_id == '1_16'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							数据管理功能强大， 实时存储与便追溯
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							设备兼容性强，可检测超大尺寸加热膜
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							先进成像系统，高精度可达微米级
						</li>

					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 440px;">
				<div class="show_product_content_3_img_16">

				</div>
			</div>
		</div>

		<div v-show="now_id == '1_17'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							双面检测，有效降低人工成本
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							AI+自研算法，高精度检测缺陷
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							模块化设计，适应多种产品检测
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 515px;">
				<div class="show_product_content_3_img_17">

				</div>
			</div>
		</div>

		<div v-show="now_id == '1_4'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">AI赋能</span>
							，产品采用了AI 检测模型，可以快速检测到目标物上的缺陷，比如锡珠，头发，少料，多料等

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化</span>
							，被测试的金属膜加载到治具上，使用扫码枪后，治具被自动推进检测区域，相机采集图片，进行缺陷检测

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以检测到小至0.1毫米（直径）的异物

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							假点少，在线打标判废
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							高度智能化建模，一键导入Gerber资料
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							检测速度快，可达4-6m/min
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							使用正面光，精准检测20μm的微开微短，检测幅宽250mm-520mm
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 1050px;">
				<div class="show_product_content_3_img_1"></div>
				<div class="show_product_content_3_img_1_4"></div>
			</div>
		</div>

		<div v-show="now_id == '4_4'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以精准识别各种异物。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化</span>
							，被检测的防尘盖加载到治具上，治具被自动推进检测区域，相机采集图片，进行缺陷检测
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">AI赋能</span> -->
							使用我司深度学习算法，收集NG样本，进行打标训练，针对一些误检区域进行屏蔽区训练，操作简便，识别率高。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化</span> -->
							通过图像分割输出不同缺陷的概率图，实现缺陷分类以及面积管控筛选。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							深度学习算法高效稳定，检测良率达99%。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							实现运控视觉一体化，方便操作。


						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 320px;">
				<div class="show_product_content_51">

				</div>
			</div>
		</div>

		<div v-show="now_id == '4_5'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以精准识别各种异物。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化</span>
							，被检测的电池仓加载到治具上，治具被自动推进检测区域，相机采集图片，进行缺陷检测
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							深度学习算法高效稳定，检测良率达99%。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							实现运控视觉一体化，方便操作。


						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<!-- 			<div class="show_product_content_3_layout" style="height: 320px;">
						<div class="show_product_content_3_img_2">
							
						</div>
					</div> -->
		</div>

		<div v-show="now_id == '4_6'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以精准识别各种异物。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化</span>
							，被检测的电池仓加载到治具上，治具被自动推进检测区域，相机采集图片，进行缺陷检测
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							深度学习算法高效稳定，检测良率达99%。


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							实现运控视觉一体化，方便操作。


						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<!-- 			<div class="show_product_content_3_layout" style="height: 320px;">
						<div class="show_product_content_3_img_2">
							
						</div>
					</div> -->
		</div>

		<div v-show="now_id == '1_8'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以实现精准识别


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化</span> -->
							高分辨率、高可靠性、全自动
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							采用全新的数字图像方案，支持网络传输数据


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							多种夹具对应不同的产品的测试
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							生成详细报告便于记录数据
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 650px;">
				<div class="show_product_content_show_1">

				</div>
			</div>
		</div>

		<div v-show="now_id == '1_9'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以精准识别各种样本


						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化</span> -->
							质量检测，微米级别测量
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高精度</span> -->
							光纤形状、角度识别、尺寸识别等
						</li>

						<li style="font-size: 18px;margin-top: 5px;">
							辅助生产，辅助设备仪器调试校准等
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							实现运控视觉一体化，方便操作
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 480px;">
				<div class="show_product_content_3_img_9_1">

				</div>
			</div>
		</div>

		<div v-show="now_id == '2_1'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化管理：</span>
							无需人工干预，系统通过视觉识别设备和操作人员，自动完成借还设备记录
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">实时库存更新：</span>
							确保设备库存信息的实时性和准确性，减少库存错误
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高效管理：</span>
							减少人工操作时间，提升仓库管理效率
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							自动监控工作人员从仓库中取走或归还设备的操作
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							实时库存统计
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							人员身份确认
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 380px;">
				<div class="show_product_content_3_img_4"></div>
				<div class="show_product_content_3_img_5"></div>
				<div class="show_product_content_3_img_6"></div>
			</div>
		</div>

		<div v-show="now_id == '2_2'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化管理：</span> -->
							实时监控光斑形状以及变化
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">实时库存更新：</span> -->
							测量激光光束的M²大小、束腰直径D0、发散角theta、椭圆度等
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高效管理：</span> -->
							符合国际ISO11146标准
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							2D，3D 伪彩色光束轮廓
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							产品测量功率范围、测量波长可定制
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 700px;">
				<div class="show_product_content_3_img_7"></div>
				<div class="show_product_content_3_img_7_1"></div>
			</div>
		</div>
		<div v-show="now_id == '2_3'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化管理：</span> -->
							实时处理模拟飞机屏幕视频流
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">实时库存更新：</span> -->
							框选识别功能
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高效管理：</span> -->
							多目标识别
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							可以识别飞行高度与飞行过载
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 600px;">
				<div class="show_product_content_3_img_8">

				</div>
			</div>
		</div>

		<div v-show="now_id == '2_4'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					产品特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">图片预处理：</span>
							使用OpenCV读取图像文件，对图像进行裁剪，自适应阈值二值化，轮廓获取
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">圆的识别：</span>
							采用霍夫圆算法提取图片中的圆
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">角度计算：</span>
							计算圆心连接线和轴线之间的夹角
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 340px;">
				<div class="show_product_content_3_img_9"></div>
				<div class="show_product_content_3_img_10"></div>
				<div class="show_product_content_3_img_11"></div>
			</div>
		</div>

		<div v-show="now_id == '2_5'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					系统特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度：</span>
							检测系统采用了高精度的相机进行采样，可实现精准识别
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高度准确性：</span> -->
							深度学习算法高效稳定，检测识别率达99%。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">实时响应性：</span> -->
							实现运控视觉一体化，方便操作。
						</li>

						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化与智能化：</span> -->
							质量检测，微米级别测量
						</li>
						<!-- 								<li style="font-size: 18px;margin-top: 5px;">
									<span style="color:#00ffff;font-size: 18px;">实时监控与数据分析：</span>
									系统应能实时监控设备状态
								</li> -->
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 450px;">
				<div class="show_product_content_img_57"></div>
				<!-- <div class="show_product_content_3_img_12_arrow"></div> -->

			</div>
		</div>

		<div v-show="now_id == '2_6'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					系统特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">高度准确性：</span> -->
							不同物联感知传感器统一管理
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">实时响应性：</span> -->
							丰富的行业应用场景
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">稳定与鲁棒性：</span> -->
							提供统一RESTful API 接口，支持下载
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">自动化与智能化：</span> -->
							软件完全自主研发，提供定制化服务
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<!-- <span style="color:#00ffff;font-size: 18px;">实时监控与数据分析：</span> -->
							部署灵活，兼容性好
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<!-- 					<div class="show_product_content_3_layout" style="height: 610px;">
						<div class="show_product_content_3_img_12_arrow"></div>
						<div class="show_product_content_3_img_12"></div>
						
					</div> -->
		</div>

		<div v-show="now_id == '2_7'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					<!-- 系统特点 -->
				</div>
				<div class="show_product_content_2_content">
					<ul>

					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<!-- 					<div class="show_product_content_3_layout" style="height: 610px;">
						
						<div class="show_product_content_show_2"></div>
						
					</div> -->
		</div>
		<div v-show="now_id == '1_10'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					结构组成
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							机械臂：通常由多个关节和连杆组成，具有多个自由度，能够在三维空间内灵活运动，以实现对不同位置和姿态物体的操作。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							视觉检测系统：包括相机、镜头、光源等硬件设备，以及图像处理软件。相机负责采集图像，镜头用于调整成像效果，光源为物体提供均匀的照明，以提高图像质量。图像处理软件则对采集到的图像进行分析和处理，提取出有用的信息。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							控制系统：负责协调机械臂和视觉检测系统的工作，根据视觉系统提供的信息，控制机械臂的运动轨迹和动作，同时还可以对整个检测过程进行监控和管理，实现自动化的检测流程。
						</li>

					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
		</div>
		<div v-show="now_id == '1_11'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					结构组成
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							光学成像系统：包括相机、镜头、光源等，相机负责捕捉产品外观图像，镜头用于清晰成像，光源则为成像提供均匀照明，以突出产品表面特征。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							机械传动系统：用于实现产品在检测区域内的精确移动和定位，确保产品各个部位都能被准确检测到，同时保证检测过程的稳定性和重复性。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							图像处理与控制系统：对采集到的图像进行分析处理，判断产品是否合格，并对缺陷进行分类、定位和记录。控制系统还负责协调光学成像系统和机械传动系统的工作，实现检测过程的自动化。
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
		</div>
		<div v-show="now_id == '1_12'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					结构组成
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							检测单元：包含各类检测传感器，如视觉相机、激光测距仪、压力传感器等，负责对产品的外观、尺寸、性能等参数进行检测。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							传输单元：由传送带、辊筒等组成，用于将产品平稳地输送通过检测区域，确保产品在检测过程中保持正确的位置和姿态。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							控制系统：作为设备的“大脑”，接收检测单元传来的数据，进行分析判断，并发出控制信号，实现对检测过程以及与其他设备联动的精确控制。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							执行单元：根据控制系统的指令，对不合格产品进行相应处理，如剔除、标记等，同时可与上下游生产设备进行联动，实现生产过程的自动化衔接。
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
		</div>
		<div v-show="now_id == '1_13'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					<!-- 结构组成 -->
				</div>
				<div class="show_product_content_2_content">
					<!-- <ul>
						<li style="font-size: 18px;margin-top: 5px;">
							检测单元：包含各类检测传感器，如视觉相机、激光测距仪、压力传感器等，负责对产品的外观、尺寸、性能等参数进行检测。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							传输单元：由传送带、辊筒等组成，用于将产品平稳地输送通过检测区域，确保产品在检测过程中保持正确的位置和姿态。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							控制系统：作为设备的“大脑”，接收检测单元传来的数据，进行分析判断，并发出控制信号，实现对检测过程以及与其他设备联动的精确控制。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							执行单元：根据控制系统的指令，对不合格产品进行相应处理，如剔除、标记等，同时可与上下游生产设备进行联动，实现生产过程的自动化衔接。
						</li>
					</ul> -->
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
		</div>
		<div v-show="now_id == '1_14'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					结构组成
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							红外探测器：是设备的核心部件，用于探测红外线并将其转化为电信号，常见的有热释电探测器、光子探测器等。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							光学系统：包括红外镜头、滤光片等，用于收集和聚焦红外线，使红外探测器能够接收到清晰的红外信号，并过滤掉其他波段的光线干扰。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							信号处理单元：对红外探测器输出的电信号进行放大、滤波、数字化等处理，并通过特定的算法进行图像重建和分析，提取出有用的信息。
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							显示单元：将处理后的红外图像显示出来，以便操作人员观察和分析。
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
		</div>
		<div v-show="now_id == '2_8'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					系统特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">AI赋能</span>
							，产品采用了AI 检测模型，可以快速检测到金属膜上的缺陷，比如锡珠，头发，少料，多料等

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化</span>
							，被测试的金属膜加载到治具上，使用扫码枪后，治具被自动推进检测区域，相机采集图片，进行缺陷检测

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							，检测系统采用了高精度的相机进行采样，可以检测到小至0.1毫米（直径）的异物

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							基于视觉的工业产品缺陷检测，可以精准的检测到产品上的裂缝，异物，锡珠等

						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 430px;">

				<div class="show_product_content_3_img_1_1"></div>
				<div class="show_product_content_3_img_1_2"></div>

			</div>
		</div>
		<div v-show="now_id == '2_9'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					系统特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">数据采集</span>
							：实时收集储能电池的运行数据。

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">状态监测</span>
							：持续监控电池状态，确保正常运行。

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">状态监测</span>
							：提供安全保障，防止电池过充、过放等危险情况。

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">能量管理</span>
							：提供安全保障，防止电池过充、过放等危险情况。

						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 430px;">

				<div class="show_product_content_3_show_9_1"></div>
				<!-- <div class="show_product_content_3_img_1_2"></div> -->

			</div>
		</div>
		<div v-show="now_id == '2_10'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					系统特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">提高运营效率</span>
							：自动化流程减少延误，提升响应速度。

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">优化资源配置</span>
							：全面了解资源状况，实现合理分配和利用。

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高精度</span>
							：准确及时的信息支持，降低决策风险。

						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">增强竞争力</span>
							：满足客户需求，提升质量，优化供应链管理。

						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
		</div>
		<div v-show="now_id == '4_7'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
				</div>
				<div class="show_product_content_2_content">
					<ul>

					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
		</div>
		<div v-show="now_id == '4_8'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
				</div>
				<div class="show_product_content_2_content">
					<ul>

					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
		</div>
		<div v-show="now_id == '4_9'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
				</div>
				<div class="show_product_content_2_content">
					<ul>

					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
		</div>
		<div v-show="now_id == '4_10'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
				</div>
				<div class="show_product_content_2_content">
					<ul>

					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
		</div>

		<div v-show="now_id == '4_1'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					系统特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">高度准确性：</span>
							能够准确识别设备的潜在故障、异常行为
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">实时响应性：</span>
							具备实时响应能力，一旦发现异常，应能迅速生成预警
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">稳定与鲁棒性：</span>
							具有高精度的识别和分析能力，同时应具有抗干扰、抗噪声和抗环境变化的能力
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化与智能化：</span>
							能自动化执行巡检任务，通过AI学习和优化，提高预警的准确性和效率，减少人工干预
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">实时监控与数据分析：</span>
							系统应能实时监控设备状态
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 610px;">
				<div class="show_product_content_3_img_12_arrow"></div>
				<div class="show_product_content_3_img_12"></div>

			</div>
		</div>

		<div v-show="now_id == '4_2'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					系统特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">车牌信息识别精度：</span>
							高精度的车牌信息识别能力
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">系统处理速度：</span>
							实时响应，确保车辆的快速进出
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">车辆追踪与定位：</span>
							实时追踪和定位车辆的位置
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">安全监控：</span>
							具备车辆安全监控功能，如超速、疲劳驾驶、违规行为等
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">安全性与隐私保护：</span>
							处理车牌信息时，确保数据的安全性和隐私保护
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout" style="height: 790px;">
				<div class="show_product_content_3_img_13"></div>
			</div>
		</div>

		<div v-show="now_id == '4_3'">
			<div class="show_product_content_2_layout">
				<div class="show_product_content_2_title">
					系统特点
				</div>
				<div class="show_product_content_2_content">
					<ul>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">预测准确性：</span>
							准确预测和识别高压设备的异常，如电缆过热、破损等
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">预警速度：</span>
							能快速响应，一旦发现异常，应能立即通知维护人员并启动应急处理程序
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">实时监控与数据分析：</span>
							实时监控设备状态，并通过大数据分析，提供故障预警和预防性维护
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">精度与稳定性：</span>
							具备高精度的设备状态监测和故障定位能力
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">自动化与智能化：</span>
							能实现自动化巡检，减少人工干预，提高效率
						</li>
						<li style="font-size: 18px;margin-top: 5px;">
							<span style="color:#00ffff;font-size: 18px;">数据分析与决策支持：</span>
							能收集并分析大量数据，生成报告，为管理层提供决策支持
						</li>
					</ul>
					<div style="width: 100%;height: 60px;"></div>
				</div>
			</div>
			<div class="show_product_content_3_layout">
				<div class="show_product_content_3_img_14"></div>
			</div>
		</div>

	</div>
	<Footer></Footer>

</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
	name: "show_product",
	components: {
		Footer
	},
	data() {
		return {
			base_url: SERVER_URL,
			api_list_data: [],
			product_list_data_1: [],
			product_list_data_2: [],
			product_list_data_3: [],
			now_id: "",
			now_id_arr: [],
			now_data: {},
			previous_data: {},
			next_data: {}
		}
	},
	mounted() {
		document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = 0
		this.init_data()
	},
	beforeRouteUpdate(to, from, next) {
		// console.log(this.$route.query.key);
		document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = 0
		// this.now_id = window.localStorage.getItem("sub_path")
		// this.now_id_arr = this.now_id.split("_")
		// if(this.now_id_arr[0] == '4'){
		// 	this.now_data =  this.product_list_data_3[parseInt(this.now_id_arr[1])-1]
		//// 	this.$GLOBAL.methods.init_header_menu("page3")
		// }
		this.init_data()

		// console.log(this.now_id_arr)
		next()
	},
	methods: {
		to_previous_data(id) {
			window.localStorage.setItem("sub_path", id);
			this.$router.push({ path: '/main/show_product', query: { key: id } });
		},
		to_next_data(id) {
			window.localStorage.setItem("sub_path", id);
			this.$router.push({ path: '/main/show_product', query: { key: id } });
		},
		init_data() {
			this.previous_data = null
			this.next_data = null

			this.api_list_data = this.$GLOBAL.api_list_data
			this.product_list_data_1 = this.$GLOBAL.product_list_data_1
			this.product_list_data_2 = this.$GLOBAL.product_list_data_2
			this.product_list_data_3 = this.$GLOBAL.product_list_data_3

			this.now_id = window.localStorage.getItem("sub_path")
			if (!this.now_id) {
				this.$router.push("/main")
			} else {
				let path_arr = this.now_id.split("_")
				this.now_id_arr = path_arr

				let arr_obj = []
				let data_type = '1_'
				if (path_arr[0] == '1') {
					arr_obj = this.product_list_data_1
					// this.now_data = this.product_list_data_1[parseInt(path_arr[1])-1]
					this.$GLOBAL.methods.init_header_menu("page2")
					data_type = "1_"
				} else if (path_arr[0] == '2') {
					arr_obj = this.product_list_data_2
					// this.now_data = this.product_list_data_2[parseInt(path_arr[1])-1]
					this.$GLOBAL.methods.init_header_menu("page2")
					data_type = "2_"
				} else if (path_arr[0] == '3') {
					arr_obj = this.api_list_data
					// this.now_data = this.api_list_data[parseInt(path_arr[1])-1]
					this.$GLOBAL.methods.init_header_menu("page2")
					data_type = "3_"
				} else if (path_arr[0] == '4') {
					arr_obj = this.product_list_data_3
					// this.now_data = this.product_list_data_3[parseInt(path_arr[1])-1]
					this.$GLOBAL.methods.init_header_menu("page3")
					data_type = "4_"
				}

				for (let i = 0; i < arr_obj.length; i++) {
					if (arr_obj[i].id == path_arr[1]) {
						this.now_data = arr_obj[i]
						// if(i>0){
						// 	this.previous_data  = arr_obj[i-1]
						// 	this.previous_data.type_id = data_type + this.previous_data.id
						// }
						// if(i<arr_obj.length-1){
						// 	this.next_data  = arr_obj[i+1]
						// 	this.next_data.type_id = data_type + this.next_data.id

						// }
					}
				}
			}
			// console.log(this.now_data)

		},
	}

}
</script>

<style></style>